import Swiper from 'swiper/dist/js/swiper';
import MatchMediaHandler from './matchmedia-handler'
import {  hasWebpSupport, isIOS } from './utils';
import { getGSheetsJSON } from './services'


// ID hoja excel
const SPREADSHEET_ID = "1mMaLl4Y3EL9phRvtlo0_PEQ_qClpGLLOaYYs1g7OnnA"
const SHEET_NUMBER = 2

// Campos validos de la hoja excel
const ACTIVE = 'gsx$visible'
const ENLACE = 'gsx$urlproducto'
const TITLE = 'gsx$title'
const TITLE_ALTERNATIVO = 'gsx$titlealternativo'
const TRACK_ID = 'gsx$codigocid'
const TRACK_ID_ALTERNATIVO = 'gsx$codigocidalternativo'
const IMAGEN_DKP = 'gsx$imagendesktop'
const IMAGEN_TB = 'gsx$imagentablet'
const IMAGEN_MB = 'gsx$imagenmobile'
const TIPO_RECURSO = 'gsx$tiporecurso'
const ENLACE_ALTERNATIVO = 'gsx$urlalternativo'
const DOBLE_ENLACE_MOBILE = 'gsx$dobleurlmobile'
const VENTA_TELEFONICA = 'gsx$ventatelefonica'


/**
 * Default breakpoints
 */
const bpMobile = 768
const filteredMenuVitrinas = ["La gran Feria"]


/**
 * Media queries para detección
 * mediante el objecto matchMedia
 */
const MOBILE_MQ = `(max-width: ${bpMobile}px)`
const DESKTOP_MQ = `(min-width: ${bpMobile + 1}px)`


//Swiper.use([ Pagination, Navigation ])

export default class SliderIntro {
   constructor(selector, options) {
      if (typeof Swiper === "undefined") {
         return false
      }
      this.selector = selector
      this.paramWebpAlpha = hasWebpSupport() && !isIOS ? '&fmt=webp-alpha' : '&fmt=png-alpha'
      this.paramWebp = hasWebpSupport() && !isIOS ? '&fmt=webp' : ''
      this.defaults = {}
      this.options = Object.assign(this.defaults, options)
      this.isMobile = true

      this.getData().then(data => this.renderHTML(data));
      this.initSwiper();

   }
   renderItemVitrinaImg(data , doble_enlace) {  
        console.log("imprime url telefonica" , this.isMobile)
      if (typeof data === "undefined") return
      const itemTemplate = `<div class="swiper-slide " >
                              <div  class="enlace-slider" ">
                                 <div class="wrapper-imagen-slider">
                                       <picture class="contenedor-imagen-slider">
                                             <source media="(min-width: 1281px)" srcset="${data[IMAGEN_DKP].$t} ">
                                             <source media="(max-width:1280px) and (min-width:501px)" srcset="${data[IMAGEN_TB].$t}">
                                             <source media="(max-width: 500px)" srcset="${data[IMAGEN_MB].$t}">
                                             <img class="imagen-slider swiper-lazy" data-src="${data[IMAGEN_MB].$t}" class="" />
                                       </picture>                                       
                                       <div class="wrapper-link_slider"> 
                                       <a class="element-link  ${data[TITLE_ALTERNATIVO].$t && data[TITLE_ALTERNATIVO].$t !== "" ? "middle":"" } ${doble_enlace ? "" :" only_link-mobile"}" title="${this.isMobile && data[VENTA_TELEFONICA].$t == "1" ? 'venta telefónica' : data[TITLE].$t }" href="${this.isMobile && data[VENTA_TELEFONICA].$t == "1" ? 'tel:016156002'  :`${data[ENLACE].$t}/?cid=${data[TRACK_ID].$t} ` }"></a>
                                       ${data[TITLE_ALTERNATIVO].$t && data[TITLE_ALTERNATIVO].$t !== "" ? `<a class="element-link middle ${doble_enlace ? "" :"only_link-mobile"}" title="${data[TITLE_ALTERNATIVO].$t}" href="${data[ENLACE_ALTERNATIVO].$t}/?cid=${data[TRACK_ID_ALTERNATIVO].$t}"></a>` :``}                                       
                                       </div>         
                                 </div>         
                     
                              </div>
                              <div class="spinner-loading visible" style="z-index:5;"><div class="spinner"></div></div>
                           </div>`
      return itemTemplate
   }

   renderHTML(data) {   

      new MatchMediaHandler( MOBILE_MQ, {
         onMatch: () => {
            this.isMobile = true
         }
      })
      
      new MatchMediaHandler(DESKTOP_MQ, {
         onMatch: () => {
           this.isMobile = false
         }
      })

      if (typeof data !== "undefined") {
         const arrayslide = []
         if (data.length > 0) {
            this.totalItems = data.length

            data.map((dataItem) => {              
               if(dataItem[TITLE].$t !== ""){
                  filteredMenuVitrinas.push(dataItem[TITLE].$t)
               }else {
                  filteredMenuVitrinas.push("")
               }
               if (dataItem[TIPO_RECURSO].$t === 'imagen' && dataItem[ACTIVE].$t === '1' && dataItem[DOBLE_ENLACE_MOBILE].$t === '1') {
                  arrayslide.push(this.renderItemVitrinaImg(dataItem , true))
               }else {
                  arrayslide.push(this.renderItemVitrinaImg(dataItem , false))
               }
            })
         }
         this.swiper.appendSlide(arrayslide) 
      }
   }
 
    getData() {
      return getGSheetsJSON(`https://spreadsheets.google.com/feeds/list/${SPREADSHEET_ID}/${SHEET_NUMBER}/public/full?alt=json`)
   
   }

   initSwiper() {
      this.swiper = new Swiper(this.selector, {
         slidesPerView: 1,
         autoplay: {
            delay: 8500
         },
         observer: true,
         // loop: true,
         preventClicks: false,
         preventClicksPropagation: false,
         preloadImages: false,
         lazy: {
            preloaderClass: 'spinner-loading',
         },
         pagination: {
            el: this.options.selectorPagination,
            clickable: true,

         },
         navigation: {
            nextEl: this.options.selectorBtnNext,
            prevEl: this.options.selectorBtnPrev
         },
         breakpoints: {
            700: {
               slidesPerView: 1,
            },
            480: {
               slidesPerView: 1,
            }
         },
      })
   }
}
